import {
    Center,
    Stack,
    Title,
    Text,
    Grid,
    Box,
    Group,
    Paper,
    List,
    ThemeIcon
} from '@mantine/core';
import { BookwellLogo } from 'src/components/ui/logos/BookwellLogo';
import TalentSignUpForm from 'src/components/auth/TalentSignUpForm';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Icons } from 'src/components/ui/Icons';

export default function TalentSignup() {

    return (
        <Paper shadow="md">
            <Grid gutter={0}>

                {/* Left Side - Visual */}
                <Grid.Col span={{ base: 12, md: 6 }} visibleFrom="md">
                    <Box
                        h="100%"
                        style={{
                            backgroundImage: [
                                'radial-gradient(900px circle at 72% 38%, rgba(73, 164, 255, 0.26) 0%, transparent 58%)',
                                'radial-gradient(760px circle at 22% 72%, rgba(24, 233, 199, 0.18) 0%, transparent 60%)',
                                'radial-gradient(680px circle at 55% 108%, rgba(10, 112, 255, 0.14) 0%, transparent 66%)',
                                'radial-gradient(520px circle at 88% 16%, rgba(141, 184, 255, 0.16) 0%, transparent 62%)',
                                'linear-gradient(150deg, #02050d 0%, #06142a 44%, #0b2040 72%, #0f2b4f 100%)',
                            ].join(', '),
                        }}
                    >
                        <Center h="100%" px="50">

                            <Stack gap="xl">
                                <Group gap="sm" align="center">
                                    <ThemeIcon
                                        size={60}
                                        radius="md"
                                        variant="filled"
                                        styles={{ root: { backgroundColor: 'rgba(255,255,255,0.14)' } }}
                                    >
                                        <Icon icon={Icons.talent} width={26} />
                                    </ThemeIcon>
                                    <Box>
                                        <Title order={2} size={50} fw={900} style={{ lineHeight: 1.05 }} c="white">
                                            Talent Registration
                                        </Title>
                                        <Text size="md" style={{ opacity: 0.9, maxWidth: 520 }} c="white">
                                            For djs, artists, entertainers, and independent professionals who take bookings.
                                        </Text>
                                    </Box>
                                </Group>

                                <List
                                    spacing="sm"
                                    icon={
                                        <ThemeIcon
                                            size={22}
                                            radius="xl"
                                            variant="filled"
                                            styles={{ root: { backgroundColor: 'rgba(255,255,255,0.14)' } }}
                                        >
                                            <Icon icon={Icons.successCircle} width={14} color="white" />
                                        </ThemeIcon>
                                    }
                                    styles={{
                                        itemLabel: { color: 'rgba(255,255,255,0.92)' },
                                    }}
                                    pl="0"
                                >
                                    <List.Item>Showcase your services and availability</List.Item>
                                    <List.Item>Keep your schedule organized, automatically</List.Item>
                                    <List.Item>Deliver a smoother booking experience for clients</List.Item>
                                </List>
                            </Stack>

                        </Center>
                    </Box>
                </Grid.Col>

                {/* Right Side - Form */}
                <Grid.Col span={{ base: 12, md: 6 }} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Box bg="white">
                        <Center h="100%" p={{ base: 'md', md: 'xl' }}>
                            <Stack w="100%" maw={400} gap="xl">

                                <Group>
                                    <BookwellLogo height="100" />
                                </Group>

                                <Stack gap="xs">
                                    <Title order={2} size="h1" fw={900}>Create your account</Title>
                                    <Text c="dimmed" size="sm">
                                        Set up your profile so clients can discover you and book in minutes.
                                    </Text>
                                </Stack>

                                <TalentSignUpForm />

                                <Center>
                                    <Text size="xs" c="dimmed">
                                        © 2026 Rockwell. All rights reserved.
                                    </Text>
                                </Center>

                            </Stack>
                        </Center>
                    </Box>
                </Grid.Col>

            </Grid>

        </Paper>
    );
}
